<script lang="ts">
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import type { LimitedOrderingProduct } from "@shared/types/LimitedOrderingProduct";

  export let products: LimitedOrderingProduct[];
  export let show: boolean;
  export let action: string;
  export let approvalNote: string | null;
  export let onClose;
  export let onSuccess;
</script>

<style>
  .fizz-flex-row .info-icon-wrapper {
    margin-right: 0.5rem;
  }
</style>

<div class="fizz-styles">
  <Modal closeOnBackgroundClick fizzModal medium bind:show centeredModal>
    <div class="layout-header-footer">
      <header class="fizz-modal-header">
        <p class="fizz-text-large fizz-text-strong">{action} requested products</p>
        <button type="button" class="fizz-modal-toggle fizz-modal-close" on:click={onClose}>
          <Icon type="X" height={14} width={14} />
        </button>
      </header>
      <section class="fizz-modal-main fizz-text-medium fizz-flow-16" data-grid-area="main">
        <p data-testid="modal-text">
          Are you sure you want to {action.toLocaleLowerCase()} the
          <span class="fizz-text-strong"
            >{products.length} selected {pluralize("product", products.length)}</span
          >?
        </p>
        {#if action === 'Decline'}
          <div>
            <label for="approval_note" class="fizz-label fizz-stack-4">Add a note</label>
            <textarea
              class="fizz-input-text fizz-full-width"
              bind:value={approvalNote}
              name="approval_note"
              id="approval_note"
            ></textarea>
          </div>
        {:else}
          <div class="fizz-flex-row fizz-surface-blue fizz-inset-horizontal-12 fizz-inset-vertical-8">
            <div class="fizz-text-interactive info-icon-wrapper">
              <Icon type="Info" />
            </div>
            <p class="fizz-text-small">Messages are only available for individual product requests</p>
          </div>
        {/if}
      </section>
      <footer class="fizz-modal-footer fizz-flex-row fizz-justify-end">
        <button type="button" class="fizz-button fizz-modal-toggle" on:click={onClose}>
          Cancel
        </button>
        <button type="button" class="fizz-button-secondary fizz-modal-toggle" on:click={onSuccess}>
          {action}
        </button>
      </footer>
    </div>
  </Modal>
</div>
